import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 只支持简体中文
import zhCN from './locales/zh-CN/translation.json';

const resources = {
  'zh-CN': {
    translation: zhCN
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'zh-CN',
    fallbackLng: 'zh-CN',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false,
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p']
    }
  });

// 固定 localStorage 为 zh-CN，避免旧值触发语言检测
if (typeof window !== 'undefined') {
  localStorage.setItem('i18nextLng', 'zh-CN');
}

export default i18n;
